export default {
    isApp: () => {
        if (/eastmoney/i.test(navigator.userAgent)) {
            return true;
        }
        return false;
    },
    isWeixin: () => {
        if (/MicroMessenger/i.test(navigator.userAgent)) {
            return true;
        }
        return false;
    },
    isIOS: () => {
        if (/(iPhone|iPod|iPad|iTouch|iOS)/i.test(navigator.userAgent)) {
            return true;
        }
        return false;
    },
    isAndroid() {
        if (/Android/i.test(navigator.userAgent)) {
            return true;
        }
        return false;
    },
    // isIOS() {
    //   if (/(iPhone|iPod|iPad|iTouch|iOS)/i.test(navigator.userAgent)) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }
    isPC() {
        if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
            return false;
        }
        return true;
    },
    isUC() {
        if (/uc/i.test(navigator.userAgent)) {
            return true;
        }
        return false;
    }
};
